"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TeamsIntegrationReviewStep = void 0;
var _react = _interopRequireWildcard(require("react"));
var _FolderOpenOutlined = _interopRequireDefault(require("@mui/icons-material/FolderOpenOutlined"));
var _InsertDriveFileOutlined = _interopRequireDefault(require("@mui/icons-material/InsertDriveFileOutlined"));
var _SubdirectoryArrowRight = _interopRequireDefault(require("@mui/icons-material/SubdirectoryArrowRight"));
var _material = require("@mui/material");
var _useTeamsFiles2 = require("@/hooks/useTeamsFiles");
var _treeBuilder = require("@/utils/treeBuilder");
var _TeamsIntegrationReviewStepModule = _interopRequireDefault(require("./TeamsIntegrationReviewStep.module.scss"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
// Internal tree node type for review

var TeamsIntegrationReviewStep = exports.TeamsIntegrationReviewStep = function TeamsIntegrationReviewStep() {
  var _useTeamsFiles = (0, _useTeamsFiles2.useTeamsFiles)(),
    getSelectedFiles = _useTeamsFiles.getSelectedFiles,
    getTeamsFilesByParentId = _useTeamsFiles.getTeamsFilesByParentId,
    getTeamsFileById = _useTeamsFiles.getTeamsFileById;

  // Build internal tree for review using the utility
  var reviewTreeNodes = (0, _react.useMemo)(function () {
    var selectedFiles = getSelectedFiles();
    return (0, _treeBuilder.buildTreeFromSelectedFiles)(selectedFiles, getTeamsFilesByParentId, getTeamsFileById, function (file, level) {
      return {
        id: file.id,
        name: file.name,
        folder: !!file.folder,
        category: file.category || null,
        type: file.folder ? "folder" : "file",
        level: level
      };
    });
  }, [getSelectedFiles, getTeamsFilesByParentId, getTeamsFileById]);
  var renderTreeLevel = (0, _react.useCallback)(function (items) {
    var level = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    if (!items || items.length === 0) return null;
    return items.map(function (item) {
      var type = item.type,
        id = item.id,
        name = item.name;
      return /*#__PURE__*/_react["default"].createElement(_material.Box, {
        key: id,
        display: "flex",
        flexDirection: "column"
      }, /*#__PURE__*/_react["default"].createElement(_material.Box, {
        display: "flex",
        alignItems: "center",
        height: "27px"
      }, /*#__PURE__*/_react["default"].createElement(_material.Box, {
        width: "".concat(level > 1 ? 29 * level : 0, "px")
      }), /*#__PURE__*/_react["default"].createElement(_material.Box, {
        display: "flex",
        alignItems: "center",
        gap: 1
      }, level !== 0 && /*#__PURE__*/_react["default"].createElement(_material.Box, {
        sx: {
          display: "flex",
          alignItems: "center"
        }
      }, /*#__PURE__*/_react["default"].createElement(_SubdirectoryArrowRight["default"], {
        sx: {
          color: "grey.500"
        }
      })), /*#__PURE__*/_react["default"].createElement(_material.Box, {
        sx: {
          display: "flex",
          alignItems: "center"
        }
      }, type === "folder" && /*#__PURE__*/_react["default"].createElement(_FolderOpenOutlined["default"], null), type === "file" && /*#__PURE__*/_react["default"].createElement(_InsertDriveFileOutlined["default"], null)), /*#__PURE__*/_react["default"].createElement(_material.Typography, null, name))), renderTreeLevel(item.children, level + 1));
    });
  }, []);
  var renderCategory = (0, _react.useCallback)(function (items) {
    if (!items || items.length === 0) return null;
    return items.map(function (item) {
      var id = item.id,
        category = item.category;
      return /*#__PURE__*/_react["default"].createElement(_material.Box, {
        key: id,
        display: "flex",
        flexDirection: "column"
      }, /*#__PURE__*/_react["default"].createElement(_material.Box, {
        sx: {
          display: "flex",
          alignItems: "center",
          height: "27px",
          wrap: "nowrap"
        },
        gap: 1
      }, category === null || category === void 0 ? void 0 : category.map(function (value, index) {
        return /*#__PURE__*/_react["default"].createElement(_react.Fragment, {
          key: value
        }, /*#__PURE__*/_react["default"].createElement(_material.Typography, null, value), index !== category.length - 1 && /*#__PURE__*/_react["default"].createElement(_material.Box, {
          className: _TeamsIntegrationReviewStepModule["default"].divider
        }));
      })), renderCategory(item.children));
    });
  }, []);
  return /*#__PURE__*/_react["default"].createElement(_material.Box, {
    className: _TeamsIntegrationReviewStepModule["default"].container
  }, /*#__PURE__*/_react["default"].createElement(_material.Box, {
    className: _TeamsIntegrationReviewStepModule["default"].treeView
  }, /*#__PURE__*/_react["default"].createElement(_material.Typography, {
    className: _TeamsIntegrationReviewStepModule["default"].title
  }, "Selected files"), renderTreeLevel(reviewTreeNodes)), /*#__PURE__*/_react["default"].createElement(_material.Box, {
    className: _TeamsIntegrationReviewStepModule["default"].treeView
  }, /*#__PURE__*/_react["default"].createElement(_material.Typography, {
    className: _TeamsIntegrationReviewStepModule["default"].title
  }, "Category"), renderCategory(reviewTreeNodes)));
};